module.exports = __webpack_public_path__ + "img/document-blue.dd59b9bb.svg";